import { useMemo } from "react";
import Icons from "assets";
import { CampaignFolderDTO } from "generated/schemas";
import { useEditFolderModal } from "./modals/use-edit-folder-modal";
import { useDeleteFolderModal } from "./modals/use-delete-folder-modal";

export interface FolderActionItem {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?: "default" | "error";
}

export const useFolderActions = (folder: CampaignFolderDTO | null) => {
  const { openEditFolder, editFolderModalMarkup } = useEditFolderModal();
  const { openDeleteFolder, deleteFolderModalMarkup } = useDeleteFolderModal();

  const actions = useMemo((): FolderActionItem[] => {
    if (!folder?.id) return [];

    return [
      {
        label: "Edit folder details",
        icon: <Icons.Edit className="text-gray-600 size-5" />,
        onClick: () => openEditFolder(folder),
      },
      {
        label: "Delete folder",
        icon: <Icons.Trash className="text-gray-600 size-5" />,
        onClick: () => openDeleteFolder(folder),
        variant: "error",
      },
    ];
  }, [folder?.id, openEditFolder, openDeleteFolder]);

  const modalMarkup = (
    <>
      {editFolderModalMarkup}
      {deleteFolderModalMarkup}
    </>
  );

  return {
    actions,
    modalMarkup,
  };
};
